import React from 'react';
import { ASSETS } from '../constants/assets';
import { heatAreas, heatWarnings } from '../constants/mockData';
import { AlertCircle, TrendingUp } from 'lucide-react';
export function HeatMiniPanel() {
  return <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100 flex flex-col gap-4" data-id="element-55">
      <div className="relative h-48 rounded-xl overflow-hidden" data-id="element-56">
        <img src={ASSETS.heatmapSuzhouCity} alt="Heatmap" className="w-full h-full object-cover" data-id="element-57" />
        <div className="absolute inset-0 bg-black/10 flex items-center justify-center" data-id="element-58">
          <div className="bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full flex items-center gap-2 shadow-lg" data-id="element-59">
            <TrendingUp className="size-4 text-[#66CADA]" data-id="element-60" />
            <span className="text-sm font-bold text-[#333333]" data-id="element-61">
              实时客流热度
            </span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3" data-id="element-62">
        {heatAreas.slice(0, 3).map(area => <div key={area.county} className="flex items-center justify-between p-3 bg-[#EEF8F8] rounded-xl" data-id="element-63">
            <div className="flex flex-col" data-id="element-64">
              <span className="text-sm font-bold text-[#333333]" data-id="element-65">
                {area.county}
              </span>
              <span className="text-xs text-[#666666] truncate max-w-[200px]" data-id="element-66">
                {area.mainResource}
              </span>
            </div>
            <div className="flex flex-col items-end" data-id="element-67">
              <span className={`text-xs font-bold px-2 py-0.5 rounded ${area.status === '热门' ? 'bg-[#F35B5B] text-white' : 'bg-[#46C28B] text-white'}`} data-id="element-68">
                {area.status}
              </span>
              <span className="text-lg font-black text-[#333333]" data-id="element-69">
                {area.heatScore}
              </span>
            </div>
          </div>)}
      </div>

      <div className="bg-orange-50 border border-orange-100 p-3 rounded-xl flex gap-2" data-id="element-70">
        <AlertCircle className="size-4 text-orange-500 shrink-0 mt-0.5" data-id="element-71" />
        <p className="text-xs text-orange-700 leading-relaxed" data-id="element-72">
          {heatWarnings[0]}
        </p>
      </div>
    </div>;
}